import { modalActions } from "redux/slices/modal";
import { getAppDispatch } from "utils/dispatch.util";
import http from "./http.service";
import Promisable from "./promisable.service";
const url = "/verify";
class VerificationIdentityService {
  static currentCallBack: any;
  static requestToken: any;

  static pluckRequestToken(message: any) {
    const match = message.match(/\((.*?)\)/);
    if (!match) {
      return "";
    }
    // Step 2: Extracted data inside the brackets
    const extractedData = match[1];
    return extractedData;
  }
  static openVerificationModel(successCallBack: any, message: any) {
    VerificationIdentityService.requestToken =
      VerificationIdentityService.pluckRequestToken(message);
    VerificationIdentityService.currentCallBack = successCallBack;
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(false));
  }
  static async makeVerificationCall(data: any) {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.setJWT();
    const [success]: any = await Promisable.asPromise(
      http.post(`${url}`, data)
    );
    dispatch?.(modalActions.setLoading(false));
    if (success) {
      VerificationIdentityService.currentCallBack([success, null]);
    }
  }
}
export default VerificationIdentityService;
